const NCT_SESSION_TOKEN_KEY = "nct.session.token";
const NCT_CUSTOMER_SYSTEM_NAME_KEY = "nct.customer.system.name";
const NCT_CUSTOMER_SYSTEM_LOGO_KEY = "nct.customer.system.logo";
const NCT_NEXT_LOGIN_ROUTE = "nct.next.login.route";
const logoutSubscriptions = [];
const popupLoginRequiredSubscriptions = [];
export class SessionHelper {
  static onLogout(fn) {
    logoutSubscriptions.push(fn);
  }

  static onPopupLoginRequired(fn) {
    popupLoginRequiredSubscriptions.push(fn);
  }

  static login(token) {
    sessionStorage.setItem(NCT_SESSION_TOKEN_KEY, token);
  }

  static requirePopupLogin() {
    popupLoginRequiredSubscriptions.forEach(function (fn) {
      fn();
    });
  }

  static logout() {
    const customerSystemName = this.customerSystemName;
    const customerSystemLogo = this.customerSystemLogo;

    sessionStorage.clear();

    this.addCustomerSystemName(customerSystemName);
    this.addCustomerSystemLogo(customerSystemLogo);

    logoutSubscriptions.forEach(function (fn) {
      fn();
    });

    window.history.pushState(
      "object or string",
      "Title",
      window.location.href.substring(0, window.location.href.indexOf("/", 10))
    );
  }

  static nctSessionToken() {
    return sessionStorage.getItem(NCT_SESSION_TOKEN_KEY);
  }

  static addCustomerSystemName(name) {
    sessionStorage.setItem(NCT_CUSTOMER_SYSTEM_NAME_KEY, name);
  }

  static get customerSystemName() {
    return sessionStorage.getItem(NCT_CUSTOMER_SYSTEM_NAME_KEY);
  }

  static addCustomerSystemLogo(logo) {
    sessionStorage.setItem(NCT_CUSTOMER_SYSTEM_LOGO_KEY, logo);
  }

  static get customerSystemLogo() {
    return sessionStorage.getItem(NCT_CUSTOMER_SYSTEM_LOGO_KEY);
  }

  static set nextLoginRoute(url) {
    sessionStorage.setItem(NCT_NEXT_LOGIN_ROUTE, url);
  }

  static get nextLoginRoute() {
    const route = sessionStorage.getItem(NCT_NEXT_LOGIN_ROUTE);
    return route;
  }

  static deleteNextLoginRoute() {
    sessionStorage.removeItem(NCT_NEXT_LOGIN_ROUTE);
  }
}
